import React, { useContext, useEffect, useState } from "react";
import Button from "../../components/Button";
import ListingHeaderLayout from "../../layouts/ListingHeaderLayout";
import {
  auditType,
  getConditionalContent,
  getDnsdFilterData,
  getLocalizedMessage,
  getSubCategoryFilterData,
} from "../../UtilityFunctions/utils";
import { useIntl } from "react-intl";
import Styles from "./DashboardTopContainer.module.scss";
import variables from "../../themes/base/styles/variables";
import useResponsive from "../../core/hooks/useResponsive";
import ThreeColumn from "../../core/layouts/ThreeColumn";
import { FilterOptions, Text } from "react_reusable_components";
import ProductCategoryService from "../../services/product-category-service";
import { AuthContext } from "../../globalContext/auth/authProvider";
import { auditCreationYear, userRole } from "../../constants";
import { ProductCategoryContext } from "../../globalContext/productCategory/productCategoryProvider";
import { GlobalLoaderContext } from "../../globalContext/globalLoader/globalLoaderProvider";
import AuditService from "../../services/audit-service";

const DashboardTopContainerStyle = {
  secondSectionMiddleSectionStyle: {
    display: variables.dFlex,
    gap: variables.gapSmaller,
    flexDirection: variables.flexDirection2,
    width: "100%",
    flexWrap: "wrap",
  },
  countStyle: {
    backgroundColor: "rgba(220, 0, 50, 0.12)",
    color: variables.primaryBg,
    height: variables.closeIcon,
    padding: variables.paddingXXSmall,
    display: variables.dFlex,
    justifyContent: variables.alignCenter,
    alignItems: variables.alignCenter,
    borderRadius: variables.countTagBorderRadius,
    fontSize: variables.fontSizeSmallest,
    fontWeight: variables.fontWeightBold,
    marginLeft: variables.marginSmall,
  },
};

const DashboardTopContainer = ({ setFilter, filter }) => {
  const responsive = useResponsive();
  const intl = useIntl();
  const [authState] = useContext(AuthContext);
  const [countriesList, setCountriesList] = useState([]);
  const [DnsdList, setDnsdList] = useState([]);
  const loaderDispatch = useContext(GlobalLoaderContext)[1];
  const [filterOpen, setFilterOpen] = useState({
    productCategories: false,
    subCategories: false,
    countries: false,
    auditType: false,
    year: false,
    dnsd: false,
  });
  const [showBtns, setShowBtns] = useState(true);

  const [productCategoryState, productCategoryDispatch] = useContext(
    ProductCategoryContext
  );

  useEffect(() => {
    ProductCategoryService.getProductCategoryList(
      productCategoryDispatch,
      {},
      intl,
      loaderDispatch
    );
  }, [authState?.currentRole?.id]);

  useEffect(() => {
    AuditService.getUsersList({
      loaderDispatch,
      intl,
      params: {
        roleId: userRole.DNSD,
      },
    })
      .then((data) => {
        setDnsdList(data);
      })
      .catch(() => {}); //NOSONAR
  }, [authState?.currentRole?.id]);

  useEffect(() => {
    if (authState?.currentRole?.id === userRole.ADMIN)
      ProductCategoryService.getCountries(intl).then((data) => {
        setCountriesList(data?.result);
      });
  }, [authState?.currentRole?.id]);

  const onApplySetCategoryFilter = (data) => {
    if (data) {
      setFilter((prev) => ({
        ...prev,
        subCategories: data?.find(({ isSelected }) => isSelected)?.value,
      }));
      setFilterOpen((prev) => ({
        ...prev,
        productCategories: false,
      }));
    }
  };

  useEffect(() => {
    setShowBtns(false);
    setTimeout(() => {
      setShowBtns(true);
    }, 100);
  }, [authState?.currentRole?.id]);

  return (
    <ListingHeaderLayout
      firstSection={
        <Text className={Styles["heading-text"]}>
          {getLocalizedMessage(intl, "dashboard.listHeading")}
        </Text>
      }
      secondSection={
        <ThreeColumn
          className={Styles["second-section-style"]}
          middleSectionStyle={
            DashboardTopContainerStyle.secondSectionMiddleSectionStyle
          }
          middleSection={
            showBtns && (
              <>
                <FilterOptions
                  filterData={getSubCategoryFilterData(
                    productCategoryState?.productCategoryList?.result
                  )}
                  isSingleSelect={true}
                  open={filterOpen.productCategories}
                  isMobile={!responsive.isMd}
                  onReset={() => {
                    setFilter((prev) => ({
                      ...prev,
                      subCategories: "",
                    }));
                    setFilterOpen((prev) => ({
                      ...prev,
                      productCategories: false,
                    }));
                  }}
                  setOpen={() =>
                    setFilterOpen((prev) => ({
                      ...prev,
                      productCategories: false,
                    }))
                  }
                  onApply={onApplySetCategoryFilter}
                  mainContainerWidth={700}
                  placement={getConditionalContent({
                    condition: responsive?.isMd,
                    trueValue: "bottomRight",
                    falseValue: "bottom",
                  })}
                  button={
                    <Button
                      icon={
                        <img
                          src="/icons/filter_list.svg"
                          className={Styles["filter-icon-style"]}
                          alt="Filter"
                        />
                      }
                      className={`${
                        Styles["add-Filter"]
                      } ${getConditionalContent({
                        trueValue: Styles["disabled"],
                        condition: filter.auditType === "Operational",
                      })}`}
                      type="text"
                      onClick={() =>
                        filter.auditType !== "Operational" &&
                        setFilterOpen((prev) => ({
                          ...prev,
                          productCategories: !prev.productCategories,
                        }))
                      }
                    >
                      {getLocalizedMessage(intl, "filter.label.subCategory")}
                      {getConditionalContent({
                        condition: !!filter?.subCategories,
                        falseValue: null,
                        trueValue: (
                          <span style={DashboardTopContainerStyle.countStyle}>
                            {`${1}`}
                          </span>
                        ),
                      })}
                    </Button>
                  }
                />
                {authState?.currentRole?.id === userRole.ADMIN && (
                  <FilterOptions
                    filterData={countriesList?.map(
                      ({ id: value, name: label }) => ({
                        value,
                        label,
                      })
                    )}
                    isSingleSelect={true}
                    open={filterOpen.countries}
                    isMobile={!responsive.isMd}
                    setOpen={() =>
                      setFilterOpen((prev) => ({
                        ...prev,
                        countries: false,
                      }))
                    }
                    onReset={() => {
                      setFilter((prev) => ({
                        ...prev,
                        countries: "",
                      }));
                      setFilterOpen((prev) => ({
                        ...prev,
                        countries: false,
                      }));
                    }}
                    onApply={(data) => {
                      if (data) {
                        setFilter((prev) => ({
                          ...prev,
                          countries: data?.find(({ isSelected }) => isSelected)
                            ?.value,
                        }));
                        setFilterOpen((prev) => ({
                          ...prev,
                          countries: false,
                        }));
                      }
                    }}
                    mainContainerWidth={700}
                    placement={getConditionalContent({
                      condition: responsive?.isMd,
                      trueValue: "bottomRight",
                      falseValue: "bottom",
                    })}
                    button={
                      <Button
                        icon={
                          <img
                            src="/icons/filter_list.svg"
                            className={Styles["filter-icon-style"]}
                            alt="Filter"
                          />
                        }
                        className={Styles["add-Filter"]}
                        type="text"
                        onClick={() =>
                          setFilterOpen((prev) => ({
                            ...prev,
                            countries: !prev?.countries,
                          }))
                        }
                      >
                        {getLocalizedMessage(intl, "filter.label.country")}
                        {getConditionalContent({
                          condition: !!filter?.countries,
                          falseValue: null,
                          trueValue: (
                            <span style={DashboardTopContainerStyle.countStyle}>
                              {`${1}`}
                            </span>
                          ),
                        })}
                      </Button>
                    }
                  />
                )}
                <FilterOptions
                  filterData={auditCreationYear}
                  setOpen={() =>
                    setFilterOpen((prev) => ({
                      ...prev,
                      year: false,
                    }))
                  }
                  isSingleSelect={true}
                  defaultSelectedValue={getConditionalContent({
                    condition:
                      filter.year === auditCreationYear[0].value.split("-")[0],
                    trueValue: [
                      {
                        isSelected: true,
                        value: auditCreationYear[0].value,
                      },
                    ],
                    falseValue: null,
                  })}
                  open={filterOpen.year}
                  isMobile={!responsive.isMd}
                  onReset={() => {
                    setFilter((prev) => ({
                      ...prev,
                      year: "",
                    }));
                    setFilterOpen((prev) => ({
                      ...prev,
                      year: false,
                    }));
                  }}
                  onApply={(data) => {
                    if (data) {
                      setFilter((prev) => ({
                        ...prev,
                        year: data
                          ?.find(({ isSelected }) => isSelected)
                          ?.value?.split("-")[0],
                      }));
                      setFilterOpen((prev) => ({
                        ...prev,
                        year: false,
                      }));
                    }
                  }}
                  mainContainerWidth={700}
                  placement={getConditionalContent({
                    condition: responsive?.isMd,
                    trueValue: "bottomRight",
                    falseValue: "bottom",
                  })}
                  button={
                    <Button
                      icon={
                        <img
                          src="/icons/filter_list.svg"
                          className={Styles["filter-icon-style"]}
                          alt="Filter"
                        />
                      }
                      className={Styles["add-Filter"]}
                      type="text"
                      onClick={() =>
                        setFilterOpen((prev) => ({
                          ...prev,
                          year: !prev.year,
                        }))
                      }
                    >
                      {getLocalizedMessage(intl, "filter.label.year")}
                      {getConditionalContent({
                        condition: !!filter?.year,
                        falseValue: null,
                        trueValue: (
                          <span style={DashboardTopContainerStyle.countStyle}>
                            {`${1}`}
                          </span>
                        ),
                      })}
                    </Button>
                  }
                />
                <FilterOptions
                  filterData={auditType}
                  isSingleSelect={true}
                  open={filterOpen.auditType}
                  isMobile={!responsive.isMd}
                  setOpen={() =>
                    setFilterOpen((prev) => ({
                      ...prev,
                      auditType: false,
                    }))
                  }
                  onReset={() => {
                    setFilter((prev) => ({
                      ...prev,
                      auditType: "",
                    }));
                    setFilterOpen((prev) => ({
                      ...prev,
                      auditType: false,
                    }));
                  }}
                  onApply={(data) => {
                    if (data) {
                      setFilter((prev) => ({
                        ...prev,
                        auditType: data?.find(({ isSelected }) => isSelected)
                          ?.value,
                      }));
                      setFilterOpen((prev) => ({
                        ...prev,
                        auditType: false,
                      }));
                    }
                  }}
                  mainContainerWidth={700}
                  placement={getConditionalContent({
                    condition: responsive?.isMd,
                    trueValue: "bottomRight",
                    falseValue: "bottom",
                  })}
                  button={
                    <Button
                      icon={
                        <img
                          src="/icons/filter_list.svg"
                          className={Styles["filter-icon-style"]}
                          alt="Filter"
                        />
                      }
                      className={Styles["add-Filter"]}
                      type="text"
                      onClick={() =>
                        setFilterOpen((prev) => ({
                          ...prev,
                          auditType: !prev.auditType,
                        }))
                      }
                    >
                      {getLocalizedMessage(intl, "filter.label.auditType")}
                      {getConditionalContent({
                        condition: !!filter?.auditType,
                        falseValue: null,
                        trueValue: (
                          <span style={DashboardTopContainerStyle.countStyle}>
                            {`${1}`}
                          </span>
                        ),
                      })}
                    </Button>
                  }
                />
                <FilterOptions
                  filterData={getDnsdFilterData(DnsdList)}
                  open={filterOpen.dnsd}
                  isMobile={!responsive.isMd}
                  setOpen={() =>
                    setFilterOpen((prev) => ({
                      ...prev,
                      dnsd: false,
                    }))
                  }
                  isSingleSelect={true}
                  onReset={() => {
                    setFilter((prev) => ({
                      ...prev,
                      DNSD: "",
                    }));
                    setFilterOpen((prev) => ({
                      ...prev,
                      dnsd: false,
                    }));
                  }}
                  onApply={(data) => {
                    if (data) {
                      setFilter((prev) => ({
                        ...prev,
                        DNSD: data?.find(({ isSelected }) => isSelected)?.value,
                      }));
                      setFilterOpen((prev) => ({
                        ...prev,
                        dnsd: false,
                      }));
                    }
                  }}
                  mainContainerWidth={700}
                  placement={getConditionalContent({
                    condition: responsive?.isMd,
                    trueValue: "bottomRight",
                    falseValue: "bottom",
                  })}
                  button={
                    <Button
                      icon={
                        <img
                          src="/icons/filter_list.svg"
                          className={Styles["filter-icon-style"]}
                          alt="Filter"
                        />
                      }
                      className={Styles["add-Filter"]}
                      type="text"
                      onClick={() =>
                        setFilterOpen((prev) => ({
                          ...prev,
                          dnsd: !prev.dnsd,
                        }))
                      }
                    >
                      {getLocalizedMessage(intl, "filter.label.dnsd")}
                      {getConditionalContent({
                        condition: !!filter?.DNSD,
                        falseValue: null,
                        trueValue: (
                          <span style={DashboardTopContainerStyle.countStyle}>
                            {`${1}`}
                          </span>
                        ),
                      })}
                    </Button>
                  }
                />
              </>
            )
          }
        />
      }
    />
  );
};

export default DashboardTopContainer;
